// extracted by mini-css-extract-plugin
export default {"wrapper":"SSOTestResult_wrapper_OVDA0","resultTitle":"SSOTestResult_resultTitle_Bc3vm","resultTips":"SSOTestResult_resultTips_qagpH"};